import { render, staticRenderFns } from "./WalletAmount.vue?vue&type=template&id=f1a5eeb8&"
import script from "./WalletAmount.vue?vue&type=script&lang=js&"
export * from "./WalletAmount.vue?vue&type=script&lang=js&"
import style0 from "./WalletAmount.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
